<p-panelMenu class="layout-menu" *ngIf="isLoggedIn$ | async" [model]="items"></p-panelMenu>
